"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgAngleLeftIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 15 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M.628 13.97a2.045 2.045 0 0 1 0-2.947L11.34.61a2.19 2.19 0 0 1 3.032 0 2.045 2.045 0 0 1 0 2.948L5.174 12.5l9.192 8.942a2.045 2.045 0 0 1 0 2.948 2.19 2.19 0 0 1-3.033 0L.62 13.977z' }) })));
});
exports.default = (0, react_1.memo)(SvgAngleLeftIcon);
